import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription, combineLatest, filter } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { Privilege, RolePrivilege } from 'src/app/components/catalogs/roles/services/role-privilege';

// US 6931: Read-only list; role assignments for these privileges are managed in Role Catalog
@Component({
  selector: 'rad-monitor-add-edit-privilege',
  templateUrl: './add-edit-privilege.component.html',
  styleUrls: ['./add-edit-privilege.component.scss'],
})
export class RadMonitorAddEditPrivilegeComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  rolePrivileges?: RolePrivilege[];
  rolePrivileges$!: Observable<RolePrivilege[]>;
  rolePrivilegesSubs!: Subscription;

  public radMonitorPrivileges: PrivilegeManagement[] = [];

  public loading = true;

  constructor(protected override injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.loadRolePrivileges();
  }

  override ngOnDestroy(): void {
    this.rolePrivilegesSubs?.unsubscribe();
  }

  /**
   * Builds the read-only privilege list from every privilege in the Rad Monitor (54) and Rad Location (65)
   * categories, paired with the roles currently assigned to each. Rebuilt whenever either store changes.
   */
  loadRolePrivileges() {
    // US 6931: Driven by the Privileges store instead of a hardcoded list, so names and categories stay in sync
    this.rolePrivileges$ = this.store.select((state) => state.RolePrivileges.data);
    const privileges$: Observable<Privilege[]> = this.store.select((state) => state.Privileges.data);
    this.rolePrivilegesSubs = combineLatest([privileges$, this.rolePrivileges$])
      .pipe(filter(([privileges, rolePrivileges]) => !!privileges?.length && !!rolePrivileges?.length))
      .subscribe(([privileges, rolePrivileges]) => {
        this.rolePrivileges = rolePrivileges;
        this.radMonitorPrivileges = privileges
          .filter((p) => p.privilegeCategoryID != null && RadPrivilegeCategories.includes(p.privilegeCategoryID))
          .sort((a, b) => RadPrivilegeCategories.indexOf(a.privilegeCategoryID!) - RadPrivilegeCategories.indexOf(b.privilegeCategoryID!) || (a.name ?? '').localeCompare(b.name ?? ''))
          .map((p) => ({
            name: p.name ?? '',
            privilegeId: p.id!,
            rolePrivileges: rolePrivileges.filter((x) => x.privilege === p.id && x.roleID),
          }));
        this.loading = false;
      });
  }
}

/** Rad Monitor Catalog (54) and Rad Location Catalog (65) privilege categories, in display order. */
const RadPrivilegeCategories = [54, 65];

class PrivilegeManagement {
  name!: string;
  privilegeId!: number;
  rolePrivileges?: RolePrivilege[];
}
